import { useParams, useSearchParams } from "react-router-dom";
import { ClientShellSkeleton } from "@/components/clients/ClientShellSkeleton";

/**
 * A-Block A0 — activity drawer shell.
 * Routes: /clients/:holdingId/activity/new (?kind=meeting|call|task)
 *         /clients/:holdingId/activity/:activityId
 * A4 re-orients F2/F3 CTAs here (holdingId locked + optional LE/contact/outlet).
 */
export function ActivityDrawerShell() {
  const { holdingId, activityId } = useParams<{ holdingId: string; activityId: string }>();
  const [params] = useSearchParams();
  const isNew = !activityId || activityId === "new";
  const kind = params.get("kind");
  return (
    <ClientShellSkeleton
      title={isNew ? "Нова активність" : "Активність"}
      subtitle={
        `Холдинг ${holdingId ?? ""}` +
        (activityId && !isNew ? ` · ${activityId}` : "") +
        (kind ? ` · тип ${kind}` : "")
      }
      note="Драйвер активності будується у під-етапі A4. Маршрут активний."
    />
  );
}
